/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020, 2021
 *
 *==================================================
 */
import { emeraldTheme as Emerald } from "../themes/index";
const themes = { Emerald };
const CurrentTheme = themes[process.env.REACT_APP_STORENAME || "Emerald"] ?? Emerald;
export { CurrentTheme };
